import { Component, EventEmitter, Input, Output } from '@angular/core'
import { EventModel } from '@shared/models/event.model'
import { AuthService } from '@shared/services/auth.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-event-register-button',
  templateUrl: './event-register-button.component.html',
})
export class EventRegisterButtonComponent {
  @Input() event: EventModel
  @Input() mode: 'public' | 'mine' = 'public'

  @Output() register = new EventEmitter<EventModel>()
  @Output() unregister = new EventEmitter<EventModel>()

  constructor(private router: Router, private authService: AuthService) {}

  isAuthenticated(): boolean {
    return this.authService.isLoggedIn()
  }

  onRegisterClick(): void {
    if (!this.event) {
      console.log('Missing feature: no event to register')
      return
    }
    this.register.emit(this.event)
  }

  onUnregisterClick(): void {
    if (!this.event) {
      console.log('Missing feature: no event to unregister')
      return
    }
    this.unregister.emit(this.event)
  }

  isEventFull(): boolean {
    return this.event.numberOfAttendees >= this.event.maxNumberOfAttendees
  }

  redirectToLogin(): void {
    this.router.navigate(['/login'])
  }
}
